"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Global = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _createGlobalStyles = require("./createGlobalStyles");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  custom: _propTypes.string
} : {};
var defaultProps = {
  custom: ''
};

var GlobalComponent = function GlobalComponent(_ref) {
  var custom = _ref.custom;
  return (0, _core.jsx)(_stylitas.Global, {
    styles: function styles(theme) {
      return (0, _stylitas.css)((0, _createGlobalStyles.createGlobalStyles)(theme, custom));
    }
  });
};

exports.Global = GlobalComponent;
process.env.NODE_ENV !== "production" ? GlobalComponent.propTypes = propTypes : void 0;
GlobalComponent.defaultProps = defaultProps;